import React from 'react'
import block from 'bem-cn-lite'

import { statuses } from '../../data'

class ReportChartSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHover: false
        }

        this.onMouseOver = this.onMouseOver.bind(this)
        this.onMouseLeave = this.onMouseLeave.bind(this)
    }

    onMouseOver(event) {
        this.setState({
            isHover: event.currentTarget === event.target
        })

        this.props.onSectionOver(event.currentTarget, {
            ...this.props.task,
            username: this.props.username,
        })

    }

    onMouseLeave(event) {
        this.setState({
            isHover: false
        })

        this.props.onSectionLeave()
    }

    render() {
        const b = block('ReportChartSection')
        const { count, status } = this.props.task
        const currentStatus = statuses.find(s => s.id === status)

        const style = {
            height: `${count / this.props.total * 100}%`,
            backgroundColor: `rgba(${currentStatus.color}, ${this.state.isHover ? .8 : 1})`
        }
        return (
            <div className={b({ hover: this.state.isHover, inactive: !this.props.isActive })}
                style={style}
                onMouseOver={this.onMouseOver}
                onMouseLeave={this.onMouseLeave}
            ></div>
        )
    }

}

export default ReportChartSection;